import { AccountModel, LoginHelpModalService } from 'data-ng-authentication';
import { ICommand } from 'core-ts-types';

export class AuthenticationController {
  private models: any;
  private queryModels: any;
  private flags: any;
  private styles: any;

  constructor(
    private $state: ng.ui.IStateService,
    private $injector: any,
    private ngRoutingRuleset: any,
    private accountModel: AccountModel,
    private ngMemberConfigurationDatastore: any,
    private ngAuthenticationQueryModel: any,
    private authenticationConfiguration: any,
    private ngLoginHelpModalService: LoginHelpModalService
  ) {
    this.models = {
      authentication: this.ngAuthenticationQueryModel.read(),
      configuration: this.authenticationConfiguration.read(),
      helpModal: this.ngLoginHelpModalService
    };

    this.queryModels = {
      authentication: this.ngAuthenticationQueryModel
    };

    this.flags = {
      showTermsOfUseModalLink: this.models.configuration.metadata.termsOfUseModal.enable,
      backgroundImageURL: this.ngAuthenticationQueryModel.getBackgroundImageURL(),
      showModal: this.ngLoginHelpModalService.shouldShow,
      showDialog: false
    };

    this.styles = {
      backgroundUrl: !!this.flags.backgroundImageURL
        ? { 'background-image': `url(${this.flags.backgroundImageURL})` }
        : {}
    };

    if (!this.accountModel.isLoggedIn()) {
      // Prevent another redirect to 'authentication.remote' as this CAS failure route is coming from server
      if (!this.$state.is('authentication.remote.failure')) {
        const loginConfig: any = this.ngMemberConfigurationDatastore.read((a: any) => a);
        this.$state.go(loginConfig.auth_type.loginInterface, {}, { location: 'replace' });
      }
    } else if (this.$injector.has(this.models.configuration.onLoggedInConfirmation)) {
      this.$injector.get(this.models.configuration.onLoggedInConfirmation)($state, accountModel);
    }

    this.ngRoutingRuleset.transitionWhenLoggedOut();
    this.ngRoutingRuleset.transitionWhenLoggedIn();
  }

  showLoginHelp(): void {
    this.flags.showDialog = true;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/views/authentication/authentication.ts